<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import CampaignsComponent from './CampaignsComponent.vue';

    export default {
    name: 'CampaignPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, CampaignsComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <CampaignsComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>